import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m3.948 11.333-.474.474a.667.667 0 0 0 0 .94.667.667 0 0 0 .94 0l.474-.474a.667.667 0 0 0-.94-.94M3.52 8a.667.667 0 0 0-.667-.667h-.666a.667.667 0 1 0 0 1.334h.666A.667.667 0 0 0 3.521 8m4.667-4.667a.667.667 0 0 0 .666-.666V2a.667.667 0 0 0-1.333 0v.667a.667.667 0 0 0 .667.666M3.948 4.7a.667.667 0 0 0 1.133-.47.67.67 0 0 0-.193-.47l-.474-.473a.667.667 0 0 0-.94.94zm8 .193c.174 0 .342-.07.466-.193l.473-.473a.666.666 0 1 0-.94-.94l-.426.473a.667.667 0 0 0 .44 1.133zm2.24 2.44h-.667a.667.667 0 1 0 0 1.334h.666a.666.666 0 1 0 0-1.334m-6 5.334a.666.666 0 0 0-.667.666V14a.666.666 0 1 0 1.333 0v-.667a.667.667 0 0 0-.666-.666m4.24-1.334a.667.667 0 0 0-.907.907l.473.473a.667.667 0 0 0 .94 0 .667.667 0 0 0 0-.94zm-4.24-7A3.667 3.667 0 1 0 11.854 8a3.673 3.673 0 0 0-3.666-3.667m0 6a2.334 2.334 0 1 1 0-4.667 2.334 2.334 0 0 1 0 4.667"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })